import { render, staticRenderFns } from "./UpdateBox.vue?vue&type=template&id=3a2b054d&scoped=true"
import script from "./UpdateBox.vue?vue&type=script&lang=js"
export * from "./UpdateBox.vue?vue&type=script&lang=js"
import style0 from "./UpdateBox.vue?vue&type=style&index=0&id=3a2b054d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2b054d",
  null
  
)

export default component.exports